export const localeManualOverrides: Record<string, Record<string, string>> = {
  fr: {
    'common.backToLogin': 'Retour a la connexion',
    'common.signIn': 'Se connecter',
    'login.title': 'Bon retour',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.logout': 'Se deconnecter',
    'home.likesTitle': "J'aime",
    'home.dislikesTitle': "Je n'aime pas",
    'home.files': 'fichier',
    'createXperience.submit': "Creer l'experience",
    'xperienceDetail.wait': 'Attendre',
    'xmedia.back': 'Retour',
    'xmedia.saving': 'Enregistrement...',
    'xmedia.field.type': 'Type',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.saving': 'Enregistrement...',
    'moderation.back': 'Retour',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xmedia.title.edit': 'Modifier le media Xperience'
  },
  'fr-CA': {
    'common.backToLogin': 'Retour a la connexion',
    'common.signIn': 'Se connecter',
    'login.title': 'Bon retour',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.logout': 'Se deconnecter',
    'home.likesTitle': "J'aime",
    'home.dislikesTitle': "Je n'aime pas",
    'home.files': 'fichier',
    'createXperience.submit': "Creer l'experience",
    'xperienceDetail.wait': 'Attendre',
    'xmedia.back': 'Retour',
    'xmedia.saving': 'Enregistrement...',
    'xmedia.field.type': 'Type',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.saving': 'Enregistrement...',
    'moderation.back': 'Retour',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xmedia.title.edit': 'Modifier le media Xperience'
  },
  de: {
    'common.signIn': 'Anmelden',
    'navbar.dashboard': 'Dashboard',
    'navbar.modXperiences': 'Mod. Xperiences',
    'navbar.generating': 'Wird erstellt...',
    'home.likesTitle': 'Likes',
    'home.dislikesTitle': 'Dislikes',
    'home.files': 'Datei',
    'home.filesPlural': 'Dateien',
    'beCreator.ctaSecondary': 'Ich habe bereits ein Konto',
    'createXperience.submit': 'Xperience erstellen',
    'xperienceDetail.wait': 'Warten',
    'xmedia.back': 'Zuruck',
    'xmedia.saving': 'Speichern...',
    'xmedia.field.type': 'Typ',
    'adminCreatorDetail.saving': 'Speichern...',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A'
  },
  ja: {
    'common.signIn': 'ログイン',
    'navbar.dashboard': 'ダッシュボード',
    'navbar.logout': 'ログアウト',
    'adminCreatorDetail.back': '戻る',
    'moderation.back': '戻る',
    'home.viewDetails': '詳細を見る',
    'createXperience.submit': 'Xperienceを作成',
    'xmedia.saving': '保存中...',
    'xmedia.back': '戻る'
  },
  'zh-Hans': {
    'common.signIn': '登录',
    'navbar.dashboard': '仪表板',
    'navbar.logout': '退出登录',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看详情',
    'createXperience.submit': '创建 Xperience',
    'xmedia.saving': '保存中...',
    'xmedia.back': '返回'
  },
  'zh-Hant': {
    'common.signIn': '登入',
    'navbar.dashboard': '儀表板',
    'navbar.logout': '登出',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看詳情',
    'createXperience.submit': '建立 Xperience',
    'xmedia.saving': '儲存中...',
    'xmedia.back': '返回'
  },
  'zh-HK': {
    'common.signIn': '登入',
    'navbar.dashboard': '儀表板',
    'navbar.logout': '登出',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看詳情',
    'createXperience.submit': '建立 Xperience',
    'xmedia.saving': '儲存中...',
    'xmedia.back': '返回'
  }
};
